enum SchoolRoles {
    Student = 'Student',
    Teacher = 'Teacher',
}

export default SchoolRoles;
